import {
  Component,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { Subscription } from "rxjs";

import { SocketService } from "../../../../providers";

@Component({
  selector: "dimmer-actuator",
  templateUrl: "dimmer-actuator.html",
})
export class DimmerActuatorComponent {
  @Output() endpointChange: EventEmitter<any> = new EventEmitter();
  @Output() endpointUpdateName: EventEmitter<any> = new EventEmitter();
  @Output() endpointUpdateNotification: EventEmitter<any> = new EventEmitter();

  @Input() device: any;
  @Input() endpoint: any;
  @Input() updatedName: any;
  @Input() updatedNotification: any;

  @ViewChild("rangeSlider", { read: ElementRef }) _rangeRef: ElementRef;

  public data: any;
  private ioMeasure$: Subscription;

  private currentClick;

  constructor(private socketService: SocketService) {}

  ngOnInit() {
    this.data = { ...this.endpoint };

    if (!this.data.current) {
      this.data.current = 0;
    }

    this.initSocketIO();
  }

  // ngAfterViewInit() {
  //   this._rangeRef0.nativeElement.querySelector(
  //     ".range-pin"
  //   ).textContent = `${Math.round((this.data.current[0] * 100) / 254)}`;
  //   this._rangeRef1.nativeElement.querySelector(
  //     ".range-pin"
  //   ).textContent = `${Math.round((this.data.current[1] * 100) / 254)}`;
  // }

  initSocketIO() {
    this.ioMeasure$ = this.socketService
      .onMeasureCreated()
      .subscribe((measure: any) => {
        this.updateMeasure(measure);
      });
  }

  updateMeasure(measure: any) {
    if (
      measure.device !== this.device._id ||
      measure.endpoint !== this.data._id
    ) {
      return;
    }
    this.data.current = measure.value;
  }

  // onChangeDimmer(index, value) {
  //   this.data.current[index] = value;

  //   if (index === 0) {
  //     this._rangeRef0.nativeElement.querySelector(
  //       ".range-pin"
  //     ).textContent = `${Math.round((this.data.current[0] * 100) / 254)}`;
  //   } else {
  //     this._rangeRef1.nativeElement.querySelector(
  //       ".range-pin"
  //     ).textContent = `${Math.round((this.data.current[1] * 100) / 254)}`;
  //   }

  //   this.endpointChange.emit({
  //     updated: true,
  //     _id: this.data._id,
  //     value: this.data.current,
  //   });
  // }

  onChangeDimmer(value) {
    this.data.current = value;
    this.currentClick = Date.now();

    setTimeout(() => {
      if (Date.now() - this.currentClick > 500) {
        this.endpointChange.emit({
          updated: true,
          _id: this.data._id,
          value: this.data.current,
        });
      }
    }, 600);
  }

  ngOnDestroy() {
    if (this.ioMeasure$) {
      this.ioMeasure$.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/node-actuator/actuators/dimmer-actuator/dimmer-actuator.ts